import axios, { AxiosResponse } from "axios";
import moment from "moment";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Editor } from 'primereact/editor';
import { Image } from "primereact/image";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { toast } from "react-toastify";
import { v4 as uuid4 } from "uuid";
import { AssignedModuleData, UserInfoEntity } from "../interface";
import { APIResponseEntity } from "../interface/api-responce";
import { DocumentationReqDDL } from "../interface/documentation";
import { GetOrderDetailsResp } from "../interface/order";
import { commericalHoldData, FeedbackPendingData, LocationStatusDetailEntity, productionHoldData, WebAppHandoverPendingOrderData } from "../interface/red-ribbon";
import {
  APICommericalHoldOrderDetails,
  APIFetchFeedbackPendingOrderDetails,
  APIFetchLatestSettledTXN,
  APIFindOneDocumentation,
  APIForFetchNotFeasibleOrders,
  APIForFetchPendingMappingRecordsForOrders,
  APIForFetchShopDrawingApprovalPendingOrders,
  APIForFetchShopDrawingAwaitingOrders,
  APIForFetchSocialLeadDraftOrders,
  APIGetOrderDetailsById,
  APIRedRibbonFetchCountsV1,
  APIRemoveProfilePhoto,
  APIToFetchLocationStatusDetail,
  APIToStopImpersonate,
  APIUpdateUserActivity,
  APIUplodeUserProfilePicture,
  APIWebAppHandoverPendingOrderDetails
} from "../service/api-service";
import { checkActionAuthorization, displayProjectClosingBalance, getFormattedStatusName, render30CharcterAfterDot } from "../service/shared.service";
import { getLocalStorageItem, removeLocalStorageItem, removeSessionStorageItem, setLocalStorageItem } from "../service/storage-service";
import { useFrozenScrollableTableHeaders } from "../hooks/use-frozen-scrollable-table-headers";
import { useBreadCrumb } from "../store/breadcrumb.store";
import { useObservationErrorStore } from "../store/observation-error.store";
import { useRedRibbon } from "../store/redRibbon.store";
import { toastOptObj } from "../utils/constants";
import {
  OfficeTypeEnum,
  CreditNoteResponseStatusEnumEntity,
  LocationTrackerPromiseDaysFlagEnumEntity,
  OrderStatusEnumEntity,
  PunchItemWiseStatuesEnum,
  RibbonEnumEntity,
  StorageKeyEnum,
  TBSStatusEnumEntity,
  WaltzStageEnumEntity,
  WorkOrderStatusEnumEntity
} from "../utils/enum";
import {
  IsNullOrEmptyArray,
  IsNullOrUndefined,
  IsStringNullEmptyOrUndefined,
} from "../utils/null-check";
import { handleNavigationAfterSuccessfulSignIn, isImpersonatedUser } from "../utils/shares";
import BreadCrumb from "./bread-crumb";
import CopyIDEventLink, { ChecksForInvitationPassesAvailability } from "./copy-ID-event-link";
import SolutionStatusModel from "./hearder-models/solution-status-model";
import Loader from "./loader";
import MaintenanceAlert from "./Maintenance/maintenance";
import HandoverPendingOrderPaymentInfo from "./production-planned/handover-pending-order-payment-info";
import RedRibbonDataModel from "./production-planned/red-ribbon-model";

function Header() {

  const navigate = useNavigate();

  const { pathname } = useLocation();
  const previewImgRef = useRef<HTMLImageElement | null>(null);
  const headerNavRef = useRef<HTMLElement | null>(null);

  const [showDialogHandOverPendingInfo, setShowDialogHandOverPendingInfo] = useState(false);
  const [handOverPendingOrderPaymentInfo, setHandOverPendingOrderPaymentInfo] = useState<null | WebAppHandoverPendingOrderData>(null);

  const [userData, setUserData] = useState<UserInfoEntity | null>(null);
  // const [solutionCount, setSolutionCount] = useState<number>(0);
  const [orderCount, setOrderCount] = useState<number>(0);
  const [handoverPendingOrderCount, setHandoverPendingOrderCount] = useState<number>(0);
  const [feedbackPendingOrderCount, setFeedbackPendingOrderCount] = useState<number>(0);

  const [showDialogForCopyIDInvitationLink, setShowDialogForCopyIDInvitationLink] = useState(false);

  const [productionHoldCount, setProductionHoldCount] = useState<number>(0);
  const [tbsHoldCount, setTbsHoldCount] = useState<number>(0);
  const [productionPlannedCount, setProductionPlannedCount] = useState<number>(0);
  const [inProductionCount, setInProductionCount] = useState<number>(0);
  const [promiseDaysExceededCount, setPromiseDaysExceededCount] = useState<number>(0);
  const [dispatchPlanned, setDispatchPlanned] = useState<number>(0);
  const [dispatchPlanCount, setDispatchPlanCount] = useState<number>(0);
  const [dispatchHoldCount, setDispatchHoldCount] = useState<number>(0);
  const [dispatchedCount, setDispatchedCount] = useState(0)

  const [isOrderBtnClicked, setIsOrderBtnClicked] = useState<boolean>(false);
  const [isFeedbackPendingOrderBtnClicked, setIsFeedbackPendingOrderBtnClicked] = useState<boolean>(false);
  const [isWebAppHandoverPendingOrdersBtnClicked, setIsWebAppHandoverPendingOrdersBtnClicked] = useState<boolean>(false);
  const [isSolutionBtnClicked, setIsSolutionBtnClicked] = useState<boolean>(false);
  const [isUserNameVisible, setIsUserNameVisible] = useState<boolean>(false);
  const [assignedModule, setAssignModule] = useState<AssignedModuleData[]>([]);
  const [isOpenProductionWorkOrdersDetail, setIsOpenProductionWorkOrdersDetail] = useState<boolean>(false);

  const [selectedWOStatus, setSelectedWOStatus] = useState<string>('');
  const [workOrderModelTitle, setWorkOrderModelTitle] = useState<string>('')

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [commercialHoldOrderDetails, setCommercialHoldOrderDetails] = useState<commericalHoldData[] | null>(null);
  const [feedbackPendingOrderDetails, setFeedbackPendingOrderDetails] = useState<FeedbackPendingData[] | null>(null);
  const [webappHandoverPendingOrderDetails, setWebappHandoverPendingOrderDetails] = useState<WebAppHandoverPendingOrderData[] | null>(null);
  const [lastCSSync, setLastCSSync] = useState<string | null>(null);

  const [productionHoldOrderDetails, setProductionHoldOrderDetails] = useState<productionHoldData[] | null>(null);
  const { setClose, isOpen, setOpen, isUpdate, setProductionPlannedStatus, setCount, resetRedRibbon } = useRedRibbon();
  const { autoItems: breadCrumbAutoItems, overrideItems: breadCrumbOverrideItems } = useBreadCrumb();
  const breadCrumbItems = breadCrumbOverrideItems ?? breadCrumbAutoItems;
  const { setObservationErrorStatusFilter } = useObservationErrorStore();

  useFrozenScrollableTableHeaders();


  const [mappingPendingPipelineCount, setMappingPendingPipelineCount] = useState(0);
  const [mappingPendingWinCount, setMappingPendingWinCount] = useState(0);
  const [notFeasibleOrderCount, setNotFeasibleOrderCount] = useState(0);
  const [shopDrawingAwaitingOrderCount, setShopDrawingAwaitingOrderCount] = useState(0);
  const [shopDrawingApprovalPendingOrderCount, setShopDrawingApprovalPendingOrderCount] = useState(0);
  const [socialLeadOrderCount, setSocialLeadOrderCount] = useState(0);

  const [measurementSheetPendingOrderCount, setMeasurementSheetPendingOrderCount] = useState(0);
  const [measurementSheetQueryPendingOrderCount, setMeasurementSheetQueryPendingOrderCount] = useState(0);
  const [siteNotReadyOrderCount, setSiteNotReadyOrderCount] = useState(0);
  const [shopDrawingQueryPendingOrderCount, setShopDrawingQueryPendingOrderCount] = useState(0);

  const [extraWorkOrderPendingRecords, setExtraWorkOrderPendingRecords] = useState(0);
  const [toBeSupplyInTransitRecords, setToBeSupplyInTransitRecords] = useState(0);
  const [errorWorkOrderPendingRecords, setErrorWorkOrderPendingRecords] = useState(0);
  const [creditNoteRetryCount, setCreditNoteRetryCount] = useState(0);

  const [currentSlide, setCurrentSlide] = useState(1);

  const [currentProfilePicture, setCurrentProfilePicture] = useState<string>('');

  const [showDropdown, setShowDropdown] = useState(false);

  const [content, setContent] = useState<DocumentationReqDDL[]>([]);

  const [visible, setVisible] = useState(false);
  const [technicalLevelVisible, setTechnicalLevelVisible] = useState(false);
  const [userLevelVisible, setUserLevelVisible] = useState(false);
  const [activeIndexs, setActiveIndexs] = useState<number>(0);

  const [pipelinePendingRecords, setPipelinePendingRecords] = useState([]);
  const [winPendingRecords, setWinPendingRecords] = useState([]);
  const [notFeasibleRecords, setNotFeasibleRecords] = useState([]);
  const [shopDrawingAwaitingRecords, setShopDrawingAwaitingRecords] = useState([]);
  const [shopDrawingApprovalPendingRecords, setShopDrawingApprovalPendingRecords] = useState([]);
  const [isModelPipelinePending, setIsModelPipelinePending] = useState(false);
  const [isModelWinPending, setIsModelWinPending] = useState(false);
  const [isModelNotFeasiblePendingOrder, setIsModelNotFeasiblePendingOrder] = useState(false);
  const [isModelShopDrawingAwaitingOrder, setIsModelShopDrawingAwaitingOrder] = useState(false);
  const [isModelShopDrawingApprovalPendingOrder, setIsModelShopDrawingApprovalPendingOrder] = useState(false);
  const [socialLeadDraftRecords, setSocialLeadDraftRecords] = useState([]);
  const [isModelSocialLeadDraftOrders, setIsModelSocialLeadDraftOrders] = useState(false);


  const [policyInformationRecord, setPolicyInformationRecord] = useState<{
    isShow: boolean;
    message: string;
  } | null>(null);

  const [passStatiStics, setPassStatiStics] = useState<ChecksForInvitationPassesAvailability>({
    isInvitationPassesAvailable: false,
    message: "",
    totalInvitation: 0,
    availalbeInvitation: 0,
    usedInvitation: 0,
    activeIDEventYear: 0,
  });


  const [locationStatusDetails, setLocationStatusDetails] = useState<LocationStatusDetailEntity[] | []>([]);

  const [isLocationModelOpen, setIsLocationModelOpen] = useState<boolean>(false);

  const handleLocationModelOpen = () => setIsLocationModelOpen(true);
  const handleLocationModelClose = () => setIsLocationModelOpen(false);

  const [selectedStatus, setSelectedStatus] = useState<string>('')

  const [isScreenLoader, setIsScreenLoader] = useState(false);

  const [manuallyClosed, setManuallyClosed] = useState(false);

  useEffect(() => {
    const headerEl = headerNavRef.current;
    if (!headerEl) return;

    const updateFixedHeaderHeightVar = (): void => {
      document.documentElement.style.setProperty('--app-fixed-header-height', `${headerEl.offsetHeight}px`);
    };

    updateFixedHeaderHeightVar();

    const resizeObserver = new ResizeObserver(updateFixedHeaderHeightVar);
    resizeObserver.observe(headerEl);

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        setManuallyClosed(false);
        setCurrentSlide(1);
        const userStr: string | null = localStorage.getItem(StorageKeyEnum.JB_GLASS_USER_INFO);
        const profilePictureStr: string | null = localStorage.getItem(StorageKeyEnum.JB_GLASS_USER_PROFILE_PICTURE);

        if (profilePictureStr && !IsStringNullEmptyOrUndefined(profilePictureStr)) {
          const profilePic: string = JSON.parse(profilePictureStr);
          setCurrentProfilePicture(profilePic);
        }

        if (!userStr || IsStringNullEmptyOrUndefined(userStr)) return;

        const userInfo: UserInfoEntity = JSON.parse(userStr);
        setUserData(userInfo);

        const assignedModules: AssignedModuleData[] = userInfo.assignedModule;
        if (!assignedModules || IsNullOrEmptyArray(assignedModules)) return;
        setAssignModule(assignedModules);

        const foundModule = assignedModules.some((item) => item.moduleName === RibbonEnumEntity.RED_RIBBON) &&
          assignedModules.some((item) =>
            [
              RibbonEnumEntity.COMMERCIAL_HOLD,
              RibbonEnumEntity.FEEDBACK_PENDING,
              RibbonEnumEntity.RR_PRODUCTION_HOLD_WO,
              RibbonEnumEntity.RR_TBS_HOLD_WO,
              RibbonEnumEntity.RR_PRODUCTION_PLANNED_WO,
              RibbonEnumEntity.RR_IN_PRODUCTION_WO,
              RibbonEnumEntity.RR_DISPATCH_HOLD_WO,
              RibbonEnumEntity.RR_READY_FOR_DISPATCH_WO,
              RibbonEnumEntity.RR_DISPACTH_PLANNED_WO,
              RibbonEnumEntity.RR_DELIVERED_WOS,
              RibbonEnumEntity.RR_MAPPING_PENDING_PIPELINE_ORDERS,
              RibbonEnumEntity.RR_MAPPING_PENDING_WIN_ORDERS,
              RibbonEnumEntity.SOCIAL_LEAD_ORDER,
              RibbonEnumEntity.NOT_FEASIBLE_ORDERS,
              RibbonEnumEntity.SHOP_DRAWING_AWAITING_ORDER,
              RibbonEnumEntity.SHOP_DRAWING_APPROVAL_PENDING_ORDER,
              RibbonEnumEntity.MEASUREMENT_SHEET_PENDING_ORDER,
              RibbonEnumEntity.MEASUREMENT_SHEET_QUERY_PENDING_ORDER,
              RibbonEnumEntity.SITE_NOT_READY_PENDING_ORDERS,
              RibbonEnumEntity.SHOP_DRAWING_QUERY_PENDING_ORDER,
              RibbonEnumEntity.HANDOVER_PENDING,
              RibbonEnumEntity.RR_POLICY_EXPIRY_OR_REMAINING_AMOUNT,
              RibbonEnumEntity.RR_EXTRA_WORK_ORDER_PENDING_RECORDS,
              RibbonEnumEntity.RR_ERROR_WORK_ORDER_PENDING_RECORDS,
              RibbonEnumEntity.TO_BE_SUPPLY_IN_TRANSIT_RECORDS,
              RibbonEnumEntity.RR_PROMISE_DAYS_EXCEEDED_WO,
              RibbonEnumEntity.CREDIT_NOTE_RETRY_RECORDS,
            ].includes(item.moduleName as RibbonEnumEntity)
          );

        if (!foundModule) {
          setClose();
          setCount(false);
          return;
        }

        setCount(true);
        setIsLoading(true);
        setOpen();

        const resp = await APIRedRibbonFetchCountsV1();
        if (!resp.ok) {
          console.error("Stream request failed with status:", resp.status);
          setClose();
          setIsLoading(false);
          return;
        }

        if (!resp.body) {
          console.error("No response body found — streaming not supported.");
          setClose();
          setIsLoading(false);
          return;
        }

        const reader = resp.body.getReader();
        const decoder = new TextDecoder();
        let buffer = "";
        let firstChunk = true;

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split("\n");
          buffer = lines.pop() || "";

          for (const line of lines) {
            if (!line.trim()) continue;
            try {
              const chunkData = JSON.parse(line);
              if (chunkData.CommercialHold !== undefined) setOrderCount(chunkData.CommercialHold);
              if (chunkData.FeedbackPending !== undefined) setFeedbackPendingOrderCount(chunkData.FeedbackPending);
              if (chunkData.ProductionHoldWOs !== undefined) setProductionHoldCount(chunkData.ProductionHoldWOs);
              if (chunkData.TBSHoldWOs !== undefined) setTbsHoldCount(chunkData.TBSHoldWOs);
              if (chunkData.DispatchHoldWOs !== undefined) setDispatchHoldCount(chunkData.DispatchHoldWOs);
              if (chunkData.DispatchPlannedWOs !== undefined) setDispatchPlanned(chunkData.DispatchPlannedWOs);
              if (chunkData.InProductionWOs !== undefined) setInProductionCount(chunkData.InProductionWOs);
              if (chunkData.ProductionPlannedWOs !== undefined) setProductionPlannedCount(chunkData.ProductionPlannedWOs);
              if (chunkData.ReadyForDispatchWOs !== undefined) setDispatchPlanCount(chunkData.ReadyForDispatchWOs);
              if (chunkData.DeliveredWOs !== undefined) setDispatchedCount(chunkData.DeliveredWOs);
              if (chunkData.PendingPipelineOrders !== undefined) setMappingPendingPipelineCount(chunkData.PendingPipelineOrders);
              if (chunkData.PendingWinOrders !== undefined) setMappingPendingWinCount(chunkData.PendingWinOrders);
              if (chunkData.SocialLeadOrders !== undefined) setSocialLeadOrderCount(chunkData.SocialLeadOrders);
              if (chunkData.NotFeasibleOrders !== undefined) setNotFeasibleOrderCount(chunkData.NotFeasibleOrders);
              if (chunkData.ShopDrawingAwaitingOrders !== undefined) setShopDrawingAwaitingOrderCount(chunkData.ShopDrawingAwaitingOrders);
              if (chunkData.ShopDrawingApprovalPendingOrders !== undefined) setShopDrawingApprovalPendingOrderCount(chunkData.ShopDrawingApprovalPendingOrders);
              if (chunkData.MeasurementSheetPendingOrders !== undefined) setMeasurementSheetPendingOrderCount(chunkData.MeasurementSheetPendingOrders);
              if (chunkData.MeasurementSheetQueryPendingOrders !== undefined) setMeasurementSheetQueryPendingOrderCount(chunkData.MeasurementSheetQueryPendingOrders);
              if (chunkData.SiteNotReadyPendingOrders !== undefined) setSiteNotReadyOrderCount(chunkData.SiteNotReadyPendingOrders);
              if (chunkData.ShopDrawingQueryPendingOrders !== undefined) setShopDrawingQueryPendingOrderCount(chunkData.ShopDrawingQueryPendingOrders);
              if (chunkData.HandoverPending !== undefined) setHandoverPendingOrderCount(chunkData.HandoverPending);
              if (chunkData.ErrorWorkOrderPendingRecords !== undefined) setErrorWorkOrderPendingRecords(chunkData.ErrorWorkOrderPendingRecords);
              if (chunkData.ExtraWorkOrderPendingRecords !== undefined) setExtraWorkOrderPendingRecords(chunkData.ExtraWorkOrderPendingRecords);
              if (chunkData.ToBeSupplyInTransitRecords !== undefined) setToBeSupplyInTransitRecords(chunkData.ToBeSupplyInTransitRecords);
              if (chunkData.PromiseDaysExceededWOs !== undefined) setPromiseDaysExceededCount(chunkData.PromiseDaysExceededWOs);
              if (chunkData.CreditNoteRetryRecords !== undefined) setCreditNoteRetryCount(chunkData.CreditNoteRetryRecords);
              if (chunkData.policyInformation !== undefined && chunkData.extraData && !IsNullOrUndefined(chunkData.extraData)) setPolicyInformationRecord(chunkData.extraData);

              if (firstChunk) {
                setIsLoading(false);
                firstChunk = false;
              }

            } catch (err) {
              console.error("Invalid JSON chunk:", line, err);
            }
          }
        }

        setIsLoading(false);

      } catch (error) {
        setClose();
        setIsLoading(false);
      } finally {
        if (pathname !== "/view-trader") {
          removeLocalStorageItem(StorageKeyEnum.JB_CONNECT_MEETING_START);
        }
      }
    };

    fetchData();
  }, [isUpdate, pathname, currentProfilePicture]);


  useEffect(() => {
    const hasAnyCount = (
      orderCount > 0 ||
      productionHoldCount > 0 ||
      tbsHoldCount > 0 ||
      productionPlannedCount > 0 ||
      inProductionCount > 0 ||
      dispatchPlanCount > 0 ||
      dispatchHoldCount > 0 ||
      dispatchedCount > 0 ||
      mappingPendingPipelineCount > 0 ||
      mappingPendingWinCount > 0 ||
      socialLeadOrderCount > 0 ||
      shopDrawingApprovalPendingOrderCount > 0 ||
      shopDrawingAwaitingOrderCount > 0 ||
      notFeasibleOrderCount > 0 ||
      measurementSheetPendingOrderCount > 0 ||
      measurementSheetQueryPendingOrderCount > 0 ||
      siteNotReadyOrderCount > 0 ||
      shopDrawingQueryPendingOrderCount > 0 ||
      handoverPendingOrderCount > 0 ||
      feedbackPendingOrderCount > 0 ||
      extraWorkOrderPendingRecords > 0 ||
      errorWorkOrderPendingRecords > 0 ||
      toBeSupplyInTransitRecords > 0 ||
      extraWorkOrderPendingRecords > 0 ||
      promiseDaysExceededCount > 0 ||
      creditNoteRetryCount > 0 ||
      !IsNullOrUndefined(policyInformationRecord)
    );

    if (!hasAnyCount) {
      setClose();
      setCount(false);
      setManuallyClosed(false);
    } else if (!manuallyClosed) {
      setCount(true);
      setOpen();
    }
  }, [
    orderCount,
    feedbackPendingOrderCount,
    productionHoldCount,
    tbsHoldCount,
    productionPlannedCount,
    inProductionCount,
    dispatchPlanCount,
    dispatchHoldCount,
    dispatchedCount,
    mappingPendingPipelineCount,
    mappingPendingWinCount,
    socialLeadOrderCount,
    manuallyClosed,
    shopDrawingApprovalPendingOrderCount,
    shopDrawingAwaitingOrderCount,
    notFeasibleOrderCount,
    measurementSheetPendingOrderCount,
    measurementSheetQueryPendingOrderCount,
    siteNotReadyOrderCount,
    shopDrawingQueryPendingOrderCount,
    handoverPendingOrderCount,
    policyInformationRecord,
    extraWorkOrderPendingRecords,
    toBeSupplyInTransitRecords,
    errorWorkOrderPendingRecords,
    promiseDaysExceededCount,
    creditNoteRetryCount
  ]);

  useEffect(() => {
    setTechnicalLevelVisible(
      checkActionAuthorization("upgrade", "Access to show technical level info")
    );
    setUserLevelVisible(checkActionAuthorization("upgrade", "Access to show user level info"))

  }, []);

  useEffect(() => {
    if (userLevelVisible && !technicalLevelVisible) {
      setActiveIndexs(0);
    }
    if (!userLevelVisible && technicalLevelVisible) {
      setActiveIndexs(1);
    }
  }, [technicalLevelVisible, userLevelVisible]);

  const fetchUserNameLetter = (): string => {
    let letters = "";
    if (userData && !IsNullOrUndefined(userData)) {
      const userName: string = userData.userFullName;
      const userNameArr: string[] = userName.split(" ");
      const firstWord: string = userNameArr[0];
      const lastWord: string = userNameArr[userNameArr.length - 1];
      letters =
        firstWord.charAt(0).toUpperCase() + lastWord.charAt(0).toUpperCase();
    }

    return letters;
  };


  const triggerPreview = () => {
    // ✅ Clicks the actual <img> inside PrimeReact <Image> component
    const button = previewImgRef.current?.querySelector('.p-image-preview-indicator') as HTMLElement;
    button?.click(); // ✅ simulate zoom preview
  };


  const handleFetchLocationStatusDetail = async (status: string) => {
    setIsScreenLoader(true);
    const resp = await APIToFetchLocationStatusDetail(status);
    if (!resp || resp.status !== 200 || !resp.data) {
      setIsLoading(false);
      return;
    }

    const apiRespPayload: APIResponseEntity = resp.data;

    if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
      toast.error(apiRespPayload.message || apiRespPayload.errorMsg, { ...toastOptObj });
      setIsLoading(false);
      return;
    }
    setSelectedStatus(prev => status);
    handleLocationModelOpen();
    setLocationStatusDetails(() => apiRespPayload.data.result[0].orders || []);
    setIsScreenLoader(false);
  }

  const handleLogout = async () => {
    if (isImpersonatedUser()) {
      await handleStopImpersonation();
      return;
    }

    await APIUpdateUserActivity(false);

    removeLocalStorageItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN);
    removeLocalStorageItem(StorageKeyEnum.JB_GLASS_USER_INFO);
    removeLocalStorageItem(StorageKeyEnum.JB_GLASS_USER_PROFILE_PICTURE);
    removeLocalStorageItem(StorageKeyEnum.WORK_ORDER_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.DISPATCH_MANAGER_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.SALES_PERSON_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.PRODUCTION_TEAM_WORK_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.PRODUCTION_PENDING_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.DISPATCH_HOLD_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.READY_FOR_DISPATCH_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.PRODUCTION_PLANNED_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.WORK_ORDER_TRACKER_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.LOCATION_TRACKER_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.PROJECT_TRACKER_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.PROJECT_TRACKER_ACTIVE_TAB);
    removeLocalStorageItem(StorageKeyEnum.PROJECT_TRACKER_FLAG_FILTER_REQ);
    removeLocalStorageItem(StorageKeyEnum.RM_PROJECTION_FILTER_REQ);

    setCurrentProfilePicture('');
    resetRedRibbon();
    setClose();

    navigate("/");
  };

  const handleOrderBtnClick = (): void => {
    setIsOrderBtnClicked(true)
    setIsSolutionBtnClicked(false)
    const fetchData = async (): Promise<void> => {
      setIsLoading(true)
      const resp: AxiosResponse<APIResponseEntity> = await APICommericalHoldOrderDetails();
      setIsLoading(false)
      if (resp && resp.status === 200 && resp.data && resp.data.status) {
        const apiResp: APIResponseEntity = resp.data;
        const ordersArr: commericalHoldData[] = apiResp.data.orders;
        const userVisiblePermission: string = apiResp.data.userVisibleOrderPermission

        const filteredArray: commericalHoldData[] = ordersArr.map(({ orderNumber, projectName, commercialHoldDate, finalAmtWithDiscont, userName }, index) => ({
          srNo: index + 1,
          orderNumber,
          projectName,
          commercialHoldDate: moment.utc(commercialHoldDate).format('DD/MM/YYYY'),
          finalAmtWithDiscont,
          userName,
        }));
        setCommercialHoldOrderDetails(filteredArray)

        if (!IsStringNullEmptyOrUndefined(userVisiblePermission) && userVisiblePermission === RibbonEnumEntity.SELF_PERMISSION) {
          setIsUserNameVisible(true)
        }
      }

    };
    fetchData();
  }

  const fetchFeedbackPendingOrdersBtnClick = (): void => {
    setIsFeedbackPendingOrderBtnClicked(true);

    const fetchData = async (): Promise<void> => {
      setIsLoading(true)
      const resp: AxiosResponse<APIResponseEntity> = await APIFetchFeedbackPendingOrderDetails();
      setIsLoading(false)
      if (resp && resp.status === 200 && resp.data && resp.data.status) {
        const apiResp: APIResponseEntity = resp.data;
        const ordersArr: FeedbackPendingData[] = apiResp.data.orders;
        const userVisiblePermission: string = apiResp.data.userVisibleOrderPermission

        const filteredArray: FeedbackPendingData[] = ordersArr.map(({ orderNumber, projectName, commercialWinDate, finalAmtWithDiscont, userName }, index) => ({
          srNo: index + 1,
          orderNumber,
          projectName,
          commercialWinDate: moment.utc(commercialWinDate).format('DD/MM/YYYY'),
          finalAmtWithDiscont,
          userName,
        }));
        setFeedbackPendingOrderDetails(filteredArray)

        if (!IsStringNullEmptyOrUndefined(userVisiblePermission) && userVisiblePermission === RibbonEnumEntity.SELF_PERMISSION) {
          setIsUserNameVisible(true)
        }
      }

    };
    fetchData();
  }

  const showDialogForCopyIDEventInvitationLink = (): void => {
    if (passStatiStics.totalInvitation === 0) {
      toast.error(passStatiStics.message, { ...toastOptObj });
    }

    if (passStatiStics.totalInvitation !== 0) {
      if (passStatiStics.totalInvitation === passStatiStics.usedInvitation) {
        toast.success(`All the link invites for ID ${passStatiStics.activeIDEventYear} have been shared.`, { ...toastOptObj });
      } else {
        setShowDialogForCopyIDInvitationLink(true);
      }
    }
  };

  const passStatiSticsCB = (data: ChecksForInvitationPassesAvailability): void => {
    setPassStatiStics(data);
  };

  async function removeProfilePicture(e: any) {
    if (!userData || IsStringNullEmptyOrUndefined(userData._id)) {
      return;
    }

    setIsLoading(true);

    const resp = await APIRemoveProfilePhoto(userData._id);

    if (!resp || resp.status !== 200 || !resp.data) {
      setIsLoading(false);
      return;
    }

    const apiRespPayload: APIResponseEntity = resp.data;

    if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
      toast.error(apiRespPayload.message || apiRespPayload.errorMsg, { ...toastOptObj });
      setIsLoading(false);
      return;
    }
    setIsLoading(false);
    setCurrentProfilePicture('')
    localStorage.removeItem(StorageKeyEnum.JB_GLASS_USER_PROFILE_PICTURE);
    const modifiedUserInfo = { ...userData, userProfileSignedUrl: '' };
    setUserData(modifiedUserInfo);
    setLocalStorageItem(StorageKeyEnum.JB_GLASS_USER_INFO, JSON.stringify(modifiedUserInfo));
    toast.success(apiRespPayload.message, { ...toastOptObj });
  }


  const handleWebAppHandoverPendingOrderBtnClick = (): void => {
    setIsWebAppHandoverPendingOrdersBtnClicked(true);
    setShowDialogHandOverPendingInfo(false);

    const fetchData = async (): Promise<void> => {
      setIsLoading(true)
      const resp: AxiosResponse<APIResponseEntity> = await APIWebAppHandoverPendingOrderDetails();
      setIsLoading(false)
      if (resp && resp.status === 200 && resp.data && resp.data.status) {
        const apiResp: APIResponseEntity = resp.data;
        const ordersArr: WebAppHandoverPendingOrderData[] = apiResp.data.orders;

        const lastCSSync: string | null = apiResp.data.lastCSSync;
        setLastCSSync(lastCSSync);

        const filteredArray: WebAppHandoverPendingOrderData[] = ordersArr.map((item, index) => {
          return {
            ...item,
            srNo: index + 1,
            handoverPendingDate: moment.utc(item.handoverPendingDate).format('DD/MM/YYYY'),
          };
        });

        setWebappHandoverPendingOrderDetails(filteredArray)
      }
    };
    fetchData();
  }

  const handleCloseBtn = (): void => {
    setIsOrderBtnClicked(false);
    setIsFeedbackPendingOrderBtnClicked(false);
    setIsWebAppHandoverPendingOrdersBtnClicked(false);
    setShowDialogHandOverPendingInfo(false);
    setIsSolutionBtnClicked(false);
  }

  const toggleBodyClass = (): void => {
    document.body.classList.toggle("mobieNavigation");
  };

  const settings = {
    beforeChange: (current: number, next: number) => {
      setCurrentSlide(next + 1);
    },
    dots: false,
    infinite: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    vertical: true,
    verticalSwiping: true,
  };

  const handleCopyLink = (): void => {
    const userDetail: any = getLocalStorageItem(StorageKeyEnum.JB_GLASS_USER_INFO)
    let link = `${process.env.REACT_APP_WEBSITE_URL}/india-design-invite/${JSON.parse(userDetail)?._id}/`;
    navigator.clipboard.writeText(link)
    toast.success("Link copied successfully.", { ...toastOptObj })
  }

  const checkRedRibbonModule = (projectStatus: string): boolean => {
    const status: boolean = assignedModule.some(
      (item: any) => (item.moduleName === RibbonEnumEntity.RED_RIBBON && item.action === 'upgrade') || item.moduleName === projectStatus)
    return status;
  }

  const checkTolengthModule = () => {
    const status: AssignedModuleData[] = assignedModule.filter(
      (item: any) =>
        (item.moduleName === RibbonEnumEntity.RED_RIBBON && item.action === 'upgrade') ||
        (item.moduleName === RibbonEnumEntity.COMMERCIAL_HOLD && orderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.FEEDBACK_PENDING && feedbackPendingOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_PRODUCTION_HOLD_WO && productionHoldCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_TBS_HOLD_WO && tbsHoldCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_PRODUCTION_PLANNED_WO && productionPlannedCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_IN_PRODUCTION_WO && inProductionCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_DISPACTH_PLANNED_WO && dispatchPlanned !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_READY_FOR_DISPATCH_WO && dispatchPlanCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_DISPATCH_HOLD_WO && dispatchHoldCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_DELIVERED_WOS && dispatchedCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_MAPPING_PENDING_PIPELINE_ORDERS && mappingPendingPipelineCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_MAPPING_PENDING_WIN_ORDERS && mappingPendingWinCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.NOT_FEASIBLE_ORDERS && notFeasibleOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.SHOP_DRAWING_AWAITING_ORDER && shopDrawingAwaitingOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.SHOP_DRAWING_APPROVAL_PENDING_ORDER && shopDrawingApprovalPendingOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.SOCIAL_LEAD_ORDER && socialLeadOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.MEASUREMENT_SHEET_PENDING_ORDER && measurementSheetPendingOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.MEASUREMENT_SHEET_QUERY_PENDING_ORDER && measurementSheetQueryPendingOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.SITE_NOT_READY_PENDING_ORDERS && siteNotReadyOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.SHOP_DRAWING_QUERY_PENDING_ORDER && shopDrawingQueryPendingOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.HANDOVER_PENDING && handoverPendingOrderCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_POLICY_EXPIRY_OR_REMAINING_AMOUNT && !IsNullOrUndefined(policyInformationRecord)) ||
        (item.moduleName === RibbonEnumEntity.RR_EXTRA_WORK_ORDER_PENDING_RECORDS && extraWorkOrderPendingRecords !== 0) ||
        (item.moduleName === RibbonEnumEntity.TO_BE_SUPPLY_IN_TRANSIT_RECORDS && toBeSupplyInTransitRecords !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_ERROR_WORK_ORDER_PENDING_RECORDS && errorWorkOrderPendingRecords !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_ERROR_WORK_ORDER_PENDING_RECORDS && errorWorkOrderPendingRecords !== 0) ||
        (item.moduleName === RibbonEnumEntity.RR_PROMISE_DAYS_EXCEEDED_WO && promiseDaysExceededCount !== 0) ||
        (item.moduleName === RibbonEnumEntity.CREDIT_NOTE_RETRY_RECORDS && creditNoteRetryCount !== 0)
    );

    return status.length;
  };

  const checkRibbonCount = () => {
    return (
      (orderCount !== 0) ||
      (feedbackPendingOrderCount !== 0) ||
      (dispatchedCount !== 0) || (productionHoldCount !== 0) || (tbsHoldCount !== 0) ||
      (productionPlannedCount !== 0) || (inProductionCount !== 0) ||
      (dispatchPlanned !== 0) || (dispatchPlanCount !== 0) ||
      (dispatchHoldCount !== 0) || (mappingPendingPipelineCount !== 0) ||
      (mappingPendingWinCount !== 0) || (notFeasibleOrderCount !== 0) || (shopDrawingAwaitingOrderCount !== 0) || (shopDrawingApprovalPendingOrderCount !== 0) ||
      (dispatchHoldCount !== 0) || (mappingPendingPipelineCount !== 0) || (mappingPendingWinCount !== 0) || (socialLeadOrderCount !== 0) ||
      (measurementSheetPendingOrderCount !== 0) ||
      (measurementSheetQueryPendingOrderCount !== 0) ||
      (siteNotReadyOrderCount !== 0) ||
      (shopDrawingQueryPendingOrderCount !== 0) ||
      (handoverPendingOrderCount !== 0) || !IsNullOrUndefined(policyInformationRecord) || (extraWorkOrderPendingRecords !== 0) ||
      (errorWorkOrderPendingRecords !== 0) ||
      (toBeSupplyInTransitRecords !== 0) ||
      (promiseDaysExceededCount !== 0) ||
      (creditNoteRetryCount !== 0)
    )
  }

  const updateProfilePicture = async (id: string, file: any,) => {
    if (file) {
      const fd: any = new FormData();
      fd.append('userProfilePicture', file);
      setIsLoading(true);
      const resp: AxiosResponse<APIResponseEntity> =
        await APIUplodeUserProfilePicture(fd, id);

      if (!resp || !resp.data || resp.status !== 200) {
        toast.error(resp.data.message, { ...toastOptObj });
        setIsLoading(false);
        return;
      }

      const axiosResp: APIResponseEntity = resp.data;
      if (
        !axiosResp ||
        !axiosResp.data ||
        !axiosResp.status ||
        axiosResp.statusCode !== 200
      ) {
        toast.error(axiosResp.message, { ...toastOptObj });
        setIsLoading(false);
        return;
      }
      setIsLoading(false);
      setCurrentProfilePicture(axiosResp.data.data.userSignedURL)
      localStorage.setItem(StorageKeyEnum.JB_GLASS_USER_PROFILE_PICTURE, JSON.stringify(axiosResp.data.data.userSignedURL));
      toast.success(axiosResp.message, { ...toastOptObj });
    } else {
      toast.error("upload valid image ", { ...toastOptObj });
    }
  }

  const footerContent = (
    <div>
      <Button label="Close" onClick={() => setVisible(false)} className='btn btn-cancel text-dark text-lg-end' />
    </div>
  );

  const fetchInfoData = async (): Promise<void> => {
    try {

      const resp: AxiosResponse<APIResponseEntity> = await APIFindOneDocumentation({ path: pathname });
      setIsLoading(false);

      if (!resp || resp.status !== 200 || !resp.data) {
        toast.error(resp.data.message, { ...toastOptObj });
        return;
      }

      if (!resp.data.status || !resp.data.data) {
        toast.error(resp.data.message, { ...toastOptObj });
        return;
      }

      setVisible(true)
      setContent([resp.data.data.data])

    } catch (error) {
      console.error("Failed to fetch user data", error);
    }
  };


  const fetchPipelinePendingMappingForOrder = async () => {
    setIsScreenLoader(true);
    const resp = await APIForFetchPendingMappingRecordsForOrders(OrderStatusEnumEntity.PIPELINE);
    if (!resp || resp.status !== 200 || !resp.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    if (!resp.data.status || !resp.data.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    setPipelinePendingRecords(resp.data.data.result);

    setIsScreenLoader(false);
  }

  const fetchWinPendingMappingForOrder = async () => {
    setIsScreenLoader(true);
    const resp = await APIForFetchPendingMappingRecordsForOrders(OrderStatusEnumEntity.COMMERCIALWIN);
    if (!resp || resp.status !== 200 || !resp.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    if (!resp.data.status || !resp.data.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    setWinPendingRecords(resp.data.data.result);

    setIsScreenLoader(false);
  }

  const fetchNotFeasibleOrder = async () => {
    setIsScreenLoader(true);
    const resp = await APIForFetchNotFeasibleOrders();
    if (!resp || resp.status !== 200 || !resp.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    if (!resp.data.status || !resp.data.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }
    setNotFeasibleRecords(resp.data.data.result[0].orders);

    setIsScreenLoader(false);
  }

  const fetchSocialLeadDraftOrders = async () => {
    setIsScreenLoader(true);
    const resp = await APIForFetchSocialLeadDraftOrders();
    if (!resp || resp.status !== 200 || !resp.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    if (!resp.data.status || !resp.data.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    setSocialLeadDraftRecords(resp.data.data.result);

    setIsScreenLoader(false);
  }

  const fetchShopDrawingAwaitingOrder = async () => {
    setIsScreenLoader(true);
    const resp = await APIForFetchShopDrawingAwaitingOrders();
    if (!resp || resp.status !== 200 || !resp.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    if (!resp.data.status || !resp.data.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    setShopDrawingAwaitingRecords(resp.data.data.result[0].orders);

    setIsScreenLoader(false);
  }

  const fetchShopDrawingApprovalPendingOrder = async () => {
    setIsScreenLoader(true);
    const resp = await APIForFetchShopDrawingApprovalPendingOrders();
    if (!resp || resp.status !== 200 || !resp.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    if (!resp.data.status || !resp.data.data) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    setShopDrawingApprovalPendingRecords(resp.data.data.result[0].orders);

    setIsScreenLoader(false);
  }

  const fetchOrderEditDetails = async (id: string, editFrom = '') => {
    if (id && !IsStringNullEmptyOrUndefined(id)) {
      setIsScreenLoader(true);
      const resp: AxiosResponse<APIResponseEntity> =
        await APIGetOrderDetailsById(id, false);
      setIsModelPipelinePending(false);
      setIsModelWinPending(false);
      setIsModelNotFeasiblePendingOrder(false);
      setIsModelShopDrawingAwaitingOrder(false);
      setIsModelShopDrawingApprovalPendingOrder(false);
      setIsModelSocialLeadDraftOrders(false);

      if (resp) {
        if (resp.data && (resp.status === 200 || resp.status === 201)) {
          const axiosResp = resp.data;
          if (
            axiosResp &&
            axiosResp.data &&
            axiosResp.status &&
            (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)
          ) {
            const orderDetail: GetOrderDetailsResp = axiosResp.data.data;

            setLocalStorageItem(
              StorageKeyEnum.WALL_ORDER_DETAILS,
              JSON.stringify(orderDetail)
            );

            if (editFrom === RibbonEnumEntity.SHOP_DRAWING_APPROVAL_PENDING_ORDER &&
              checkActionAuthorization("upgrade", "Access to SD approve")) {
              setLocalStorageItem(StorageKeyEnum.WALTZ_STAGE, WaltzStageEnumEntity.SD_APPROVE);
            } else {
              removeLocalStorageItem(StorageKeyEnum.WALTZ_STAGE);
            }
            removeLocalStorageItem(StorageKeyEnum.DRAWING_SET_DETAILS_FOR_WALTZ_ORDER);
            removeLocalStorageItem(StorageKeyEnum.EXISTING_SOLUTIONS_IDS_FOR_DRAWING_PLAN);
            removeLocalStorageItem(StorageKeyEnum.DRAWING_ANNOTATION_FOR_WALTZ_ORDER);
            removeLocalStorageItem(StorageKeyEnum.EXISTING_FLOOR_PLAN_SETS_IDS);
            removeLocalStorageItem(StorageKeyEnum.INITIAL_DRAWING_COORDINATION);
            removeLocalStorageItem(StorageKeyEnum.INITIAL_DRAWING_PLANS);
            removeLocalStorageItem(StorageKeyEnum.DRAWING_ANNOTATION);
            removeLocalStorageItem(StorageKeyEnum.DRAWING_UUID);
            removeLocalStorageItem(StorageKeyEnum.ANNOTATION_COORDINATES_FOR_WALTZ_ORDER);
            removeLocalStorageItem(StorageKeyEnum.ANNOTATION_DELETE_IDS);
            removeSessionStorageItem(
              `${StorageKeyEnum.WALTZ_ORDERS_SOLUTIONS}_${id}`
            );
            setIsScreenLoader(false);
            navigate(
              "/manage-wall-order-solution/" + id + "?fromURL=waltz-orders"
            );
          } else {
            toast.error(axiosResp.message, { ...toastOptObj });
          }
        } else {
          toast.error(resp.data.message, { ...toastOptObj });
        }
      }
      setIsScreenLoader(false);
    }
  };

  function handleCloseRibbon() {
    setClose();
    setCount(false);
    setManuallyClosed(true);
  }

  const onClickRefund = async (orderReferenceNumber: string | null | undefined, overDue: number): Promise<void> => {
    console.log(`Order # ${orderReferenceNumber} — overdue ${overDue}`);

    if (!orderReferenceNumber || (orderReferenceNumber && IsStringNullEmptyOrUndefined(orderReferenceNumber))) return;

    await fetchLatestSettledTXNAndRedirectToRefundPage(orderReferenceNumber, overDue);
  };

  const viewHandoverPendingOrderInfo = (rowData: WebAppHandoverPendingOrderData): void => {
    setShowDialogHandOverPendingInfo(true);
    setHandOverPendingOrderPaymentInfo(rowData);
  };

  const fetchLatestSettledTXNAndRedirectToRefundPage = async (orderReferenceNumber: string, overDue: number): Promise<void> => {
    console.log(`fetchLatestSettledTXNAndRedirectToRefundPage() :: Order Ref :: ${orderReferenceNumber}`);
    setIsLoading(true);
    const resp: AxiosResponse = await APIFetchLatestSettledTXN(orderReferenceNumber, overDue);
    setIsLoading(false);

    if (!resp || (resp && (resp.status !== 200 || !resp.data))) {
      setIsLoading(false); return;
    }

    const apiRespPayload: APIResponseEntity = resp.data;

    if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
      toast.error(apiRespPayload.message || apiRespPayload.errorMsg, { ...toastOptObj });
      setIsLoading(false);
      return;
    }

    const apiRespData: { transactionReferenceId: string | null; } = apiRespPayload.data;
    console.log(apiRespData);

    if (apiRespData && apiRespData.transactionReferenceId && !IsStringNullEmptyOrUndefined(apiRespData.transactionReferenceId)) {
      setIsWebAppHandoverPendingOrdersBtnClicked(false);
      setShowDialogHandOverPendingInfo(false);
      setShowDialogHandOverPendingInfo(false);

      setTimeout(() => {
        navigate(`/transactions/refund-payment/${apiRespData.transactionReferenceId}?orderReferenceNumber=${orderReferenceNumber}&overDue=${overDue}`);
      }, 100);
    }
  };

  const handleSetObservationErrorStatus = (status: string) => {
    setObservationErrorStatusFilter(status);
    navigate('/observation-errors', { replace: true });
  }

  // const handleStopImpersonation = async () => {
  //   setIsLoading(true);
  //   const resp: AxiosResponse<APIResponseEntity> = await APIToStopImpersonate();
  //   setIsLoading(false);
  //   if (resp && resp.data && resp.status === 200) {
  //     const axiosRespData: APIResponseEntity = resp.data;
  //     if (axiosRespData && axiosRespData.status) {
  //       const actionBy = axiosRespData.data.data;
  //       localStorage.setItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN, actionBy.token);
  //       localStorage.setItem(
  //         StorageKeyEnum.JB_GLASS_USER_INFO,
  //         JSON.stringify(actionBy)
  //       );
  //       const assignedModule: AssignedModuleData[] = axiosRespData.data.data.assignedModule;
  //       handleNavigationAfterSuccessfulSignIn(assignedModule , setIsLoading)
  //     } else {
  //       toast.error(resp.data.message, { ...toastOptObj })
  //     }
  //   }
  //   if (axios.isAxiosError(resp) && resp.response) {
  //     console.log(resp.response);
  //   }
  // };

  const handleStopImpersonation = async () => {
    setIsLoading(true);
    const rawUserInfo = localStorage.getItem(StorageKeyEnum.JB_GLASS_USER_INFO);
    const userInfo = rawUserInfo ? JSON.parse(rawUserInfo) : null;
    const sessionId = userInfo && userInfo.sessionId;
    const resp: AxiosResponse<APIResponseEntity> = await APIToStopImpersonate(sessionId);
    setIsLoading(false);

    if (!resp || !resp.data || resp.status !== 200) {
      if (axios.isAxiosError(resp) && resp.response) {
        console.error(resp.response);
      }
      return;
    }

    const axiosRespData: APIResponseEntity = resp.data;
    if (!axiosRespData || !axiosRespData.status) {
      toast.error(resp.data.message, { ...toastOptObj });
      return;
    }

    const returningUser = axiosRespData.data;
    localStorage.setItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN, returningUser.token);
    localStorage.setItem(StorageKeyEnum.JB_GLASS_USER_INFO, JSON.stringify(returningUser));

    setUserData(returningUser);

    const assignedModules: AssignedModuleData[] = returningUser.assignedModule;
    handleNavigationAfterSuccessfulSignIn(assignedModules, setIsLoading);
  };

  return (
    <>
      <Loader isLoading={isScreenLoader} />



      <nav
        id="scrollable-parent"
        ref={headerNavRef}
        className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row"
      >

        {isOpen && checkRibbonCount() ? (
          <div className={`sliderWrapper ${checkTolengthModule() === 1 ? "hideIfOne" : ""}`}>
            {isLoading ? (
              <div className="w-100 d-flex justify-content-center">
                <div className="pdfLoader pdfLoaderWhiteColor"></div>
              </div>
            ) : (
              <>
                <div className="counter">
                  {checkTolengthModule() > 1 ? `${currentSlide} / ${checkTolengthModule()}` : currentSlide}
                </div>
                <i className="bi bi-x-circle close" onClick={handleCloseRibbon}></i>

                <Slider {...settings}>

                  {checkRedRibbonModule(RibbonEnumEntity.COMMERCIAL_HOLD) && orderCount > 0 && (
                    <div className="text-center">
                      <span className="ordercount" onClick={handleOrderBtnClick}>
                        {orderCount} projects are on <b>commercial hold</b>
                      </span>
                    </div>
                  )}

                  {(checkRedRibbonModule(RibbonEnumEntity.RR_POLICY_EXPIRY_OR_REMAINING_AMOUNT) && policyInformationRecord && !IsNullOrUndefined(policyInformationRecord) && policyInformationRecord.isShow) && (
                    <div className="text-center">
                      <span className="ordercount" >
                        {policyInformationRecord.message}
                      </span>
                    </div>
                  )}

                  {checkRedRibbonModule(RibbonEnumEntity.FEEDBACK_PENDING) && feedbackPendingOrderCount > 0 && (
                    <div className="text-center">
                      <span className="ordercount" onClick={fetchFeedbackPendingOrdersBtnClick}>
                        {feedbackPendingOrderCount} projects are on <b>feedback pending</b>
                      </span>
                    </div>
                  )}

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_PRODUCTION_HOLD_WO) && productionHoldCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={() => {
                            setIsOpenProductionWorkOrdersDetail(true);
                            setWorkOrderModelTitle("Production Hold Work Orders");
                            setSelectedWOStatus(WorkOrderStatusEnumEntity.PRODUCTION_HOLD);
                          }}
                        >
                          {productionHoldCount} work orders, <b>production is hold</b> for commercials
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_TBS_HOLD_WO) && tbsHoldCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={() => {
                            setIsOpenProductionWorkOrdersDetail(true);
                            setWorkOrderModelTitle("TBS Hold Work Orders");
                            setSelectedWOStatus(WorkOrderStatusEnumEntity.TBS_HOLD);
                          }}
                        >
                          {tbsHoldCount} work orders, <b>TBS hold</b> until the TBS is received
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_DISPATCH_HOLD_WO) && dispatchHoldCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={() => {
                            setIsOpenProductionWorkOrdersDetail(true);
                            setWorkOrderModelTitle("Dispatch Hold Work Orders");
                            setSelectedWOStatus(WorkOrderStatusEnumEntity.DISPATCH_HOLD);
                          }}
                        >
                          {dispatchHoldCount} work orders, <b>dispatch is hold</b> for commercials
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_PRODUCTION_PLANNED_WO) && productionPlannedCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={() =>
                            navigate("/production-work-order-list", {
                              state: { tabIndex: 0, isUpdate: uuid4() },
                              replace: true,
                            })
                          }
                        >
                          {productionPlannedCount} work orders <b>production planning</b> pending
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_IN_PRODUCTION_WO) && inProductionCount > 0 && (
                      <div className="text-center">
                        <span className="ordercount" onClick={() => navigate("/production-team-work-order")}>
                          {inProductionCount} work orders are <b>in production</b>
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_PROMISE_DAYS_EXCEEDED_WO) && promiseDaysExceededCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={() => {
                            navigate("/location-tracker");
                            setProductionPlannedStatus("Location-Tracker", [
                              LocationTrackerPromiseDaysFlagEnumEntity.NEXT,
                              "7",
                            ]);
                          }}
                        >
                          {promiseDaysExceededCount} locations, <b>promise days</b> due in next 7 days
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_DISPACTH_PLANNED_WO) && dispatchPlanned > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={() => {
                            navigate("/dispatch-manager-work-order");
                            setProductionPlannedStatus("Dispatch-Manager", [
                              WorkOrderStatusEnumEntity.PLANNED_FOR_DISPATCH,
                            ]);
                          }}
                        >
                          {dispatchPlanned} work orders <b>in-transit pending</b>
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_READY_FOR_DISPATCH_WO) && dispatchPlanCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={() => {
                            navigate("/sales-person-work-order");
                            setProductionPlannedStatus("Sales-Person", [
                              WorkOrderStatusEnumEntity.READY_FOR_DISPATCH,
                            ]);
                          }}
                        >
                          {dispatchPlanCount} work orders, <b>dispatch plan</b> is awaited from you
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_DELIVERED_WOS) && dispatchedCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={() => {
                            navigate("/dispatch-manager-work-order");
                            setProductionPlannedStatus("Dispatch-Manager", [WorkOrderStatusEnumEntity.IN_TRANSIT]);
                          }}
                        >
                          {dispatchedCount} work orders <b>not delivered</b> yet
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.RR_MAPPING_PENDING_WIN_ORDERS) &&
                    mappingPendingWinCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={async () => {
                            await fetchWinPendingMappingForOrder();
                            setIsModelWinPending(true);
                          }}
                        >
                          <b>{mappingPendingWinCount} win </b>projects have mapping pending
                        </span>
                      </div>
                    )
                  }

                  {
                    checkRedRibbonModule(RibbonEnumEntity.SOCIAL_LEAD_ORDER) && socialLeadOrderCount > 0 && (
                      <div className="text-center">
                        <span
                          className="ordercount"
                          onClick={async () => {
                            await fetchSocialLeadDraftOrders();
                            setIsModelSocialLeadDraftOrders(true);
                          }}
                        >
                          <b>{socialLeadOrderCount} social lead </b> draft orders
                        </span>
                      </div>
                    )
                  }

                  {
                    (checkRedRibbonModule(RibbonEnumEntity.RR_MAPPING_PENDING_PIPELINE_ORDERS) && (mappingPendingPipelineCount !== 0))
                    && (
                      <div className="text-center">
                        <span>
                          <span className="ordercount" onClick={async () => {
                            await fetchPipelinePendingMappingForOrder();
                            setIsModelPipelinePending(true)
                          }} >
                            <b>{mappingPendingPipelineCount} pipeline </b>projects have mapping pending.
                          </span>
                        </span>
                      </div>
                    )
                  }
                  {
                    (checkRedRibbonModule(RibbonEnumEntity.NOT_FEASIBLE_ORDERS) && (notFeasibleOrderCount !== 0))
                    && (
                      <div className="text-center">
                        <span>
                          <span className="ordercount" onClick={async () => {
                            await fetchNotFeasibleOrder();
                            setIsModelNotFeasiblePendingOrder(true)
                          }} >
                            <b>{notFeasibleOrderCount} projects are not feasible.</b>
                          </span>
                        </span>
                      </div>
                    )
                  }
                  {
                    (checkRedRibbonModule(RibbonEnumEntity.SHOP_DRAWING_AWAITING_ORDER) && (shopDrawingAwaitingOrderCount !== 0))
                    && (
                      <div className="text-center">
                        <span>
                          <span className="ordercount" onClick={async () => {
                            await fetchShopDrawingAwaitingOrder();
                            setIsModelShopDrawingAwaitingOrder(true)
                          }} >
                            <b>{shopDrawingAwaitingOrderCount} projects are shop drawing awaiting.</b>
                          </span>
                        </span>
                      </div>
                    )
                  }
                  {
                    (checkRedRibbonModule(RibbonEnumEntity.SHOP_DRAWING_APPROVAL_PENDING_ORDER) && (shopDrawingApprovalPendingOrderCount !== 0))
                    && (
                      <div className="text-center">
                        <span>
                          <span className="ordercount" onClick={async () => {
                            await fetchShopDrawingApprovalPendingOrder();
                            setIsModelShopDrawingApprovalPendingOrder(true)
                          }} >
                            <b>{shopDrawingApprovalPendingOrderCount} projects are shop drawing approval pending.</b>
                          </span>
                        </span>
                      </div>
                    )
                  }
                  {
                    (checkRedRibbonModule(RibbonEnumEntity.MEASUREMENT_SHEET_PENDING_ORDER) && (measurementSheetPendingOrderCount !== 0))
                    && (
                      <div className="text-center">
                        <span>
                          <span className="ordercount" onClick={async () => {

                          }} >
                            <b>{measurementSheetPendingOrderCount} projects are measurement sheet pending.</b>
                          </span>
                        </span>
                      </div>
                    )
                  }
                  {
                    (checkRedRibbonModule(RibbonEnumEntity.MEASUREMENT_SHEET_QUERY_PENDING_ORDER) && (measurementSheetQueryPendingOrderCount !== 0))
                    && (
                      <div className="text-center">
                        <span>
                          <span className="ordercount" onClick={async () => {
                            handleFetchLocationStatusDetail(PunchItemWiseStatuesEnum.MEASUREMENT_SHEET_QUERY)
                          }} >
                            <b>{measurementSheetQueryPendingOrderCount} projects are measurement sheet query pending.</b>
                          </span>
                        </span>
                      </div>
                    )
                  }
                  {
                    (checkRedRibbonModule(RibbonEnumEntity.SITE_NOT_READY_PENDING_ORDERS) && (siteNotReadyOrderCount !== 0))
                    && (
                      <div className="text-center">
                        <span>
                          <span className="ordercount" onClick={async () => {

                          }} >
                            <b>{siteNotReadyOrderCount} projects are site not ready.</b>
                          </span>
                        </span>
                      </div>
                    )
                  }
                  {
                    (checkRedRibbonModule(RibbonEnumEntity.SHOP_DRAWING_QUERY_PENDING_ORDER) && (shopDrawingQueryPendingOrderCount !== 0))
                    && (
                      <div className="text-center">
                        <span>
                          <span className="ordercount" onClick={async () => {

                          }} >
                            <b>{shopDrawingQueryPendingOrderCount} projects shop drawing query pending.</b>
                          </span>
                        </span>
                      </div>
                    )
                  }


                  {
                    checkRedRibbonModule(RibbonEnumEntity.HANDOVER_PENDING) && handoverPendingOrderCount > 0 && (
                      <div className="text-center">
                        <span className="ordercount"
                          onClick={handleWebAppHandoverPendingOrderBtnClick}
                        >
                          {handoverPendingOrderCount} projects are on <b>handover pending</b>
                        </span>
                      </div>
                    )
                  }


                  {checkRedRibbonModule(RibbonEnumEntity.RR_EXTRA_WORK_ORDER_PENDING_RECORDS) && extraWorkOrderPendingRecords > 0 && (
                    <div className="text-center">
                      <span className="ordercount" onClick={() => {
                        handleSetObservationErrorStatus(PunchItemWiseStatuesEnum.EXTRA_COST_APPROVAL_PENDING)
                      }} >
                        {extraWorkOrderPendingRecords} errors are on <b>Extra Cost Approval Pending.</b>
                      </span>
                    </div>
                  )}

                  {checkRedRibbonModule(RibbonEnumEntity.RR_ERROR_WORK_ORDER_PENDING_RECORDS) && errorWorkOrderPendingRecords > 0 && (
                    <div className="text-center">
                      <span className="ordercount" onClick={() => {
                        handleSetObservationErrorStatus(PunchItemWiseStatuesEnum.ERROR_COST_APPROVAL_PENDING)
                      }} >
                        {errorWorkOrderPendingRecords} errors are on <b>Error Cost Approval Pending.</b>
                      </span>
                    </div>
                  )}

                  {checkRedRibbonModule(RibbonEnumEntity.TO_BE_SUPPLY_IN_TRANSIT_RECORDS) && toBeSupplyInTransitRecords > 0 && (
                    <div className="text-center">
                      <span className="ordercount"
                        onClick={() => {
                          // opens Send For TBS filtered on "In Transit"; a user without that page (store only) still lands on the store list
                          navigate(checkActionAuthorization("list", "Send For TBS") ? '/TBS/send-for-tbs' : '/TBS/tbs-store', {
                            replace: true,
                            state: { status: TBSStatusEnumEntity.IN_TRANSIT },
                          });
                        }} >
                        {toBeSupplyInTransitRecords} records are on <b>To Be Supply In Transit.</b>
                      </span>
                    </div>
                  )}

                  {checkRedRibbonModule(RibbonEnumEntity.CREDIT_NOTE_RETRY_RECORDS) && creditNoteRetryCount > 0 && (
                    <div className="text-center">
                      <span
                        className="ordercount"
                        onClick={() => {
                          navigate("/transactions/credit-note", {
                            state: { cdnStatus: CreditNoteResponseStatusEnumEntity.RETRY },
                          });
                        }}
                      >
                        {creditNoteRetryCount} credit {creditNoteRetryCount === 1 ? 'note is' : 'notes are'} on <b>Retry Status</b>
                      </span>
                    </div>
                  )}
                </Slider >
              </>
            )
            }
          </div >
        ) : null}

        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
          <div className="me-3">
            <button className="sidebar-favicon-logo" type="button">
              <img src="assets/images/favicon.png" alt="jb-glass" />
            </button>
          </div>
          <div>
            <a className="navbar-brand brand-logo" href="index.html">
              <img src="assets/images/logo.png" alt="logo" />
            </a>
            <a className="navbar-brand brand-logo-mini" href="index.html">
              <img src="assets/images/logo.png" alt="logo" />
            </a>
          </div>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-top">
          <div className="d-flex flex-column">
            <div>
              <ul className="navbar-nav">
                <li className="nav-item font-weight-semibold d-none d-lg-block ms-0">
                  <h1 className="welcome-text">
                    Hello,&nbsp;
                    <span className="text-black fw-bold">
                      {userData && render30CharcterAfterDot(userData.userFullName)}
                    </span>
                    <small>&nbsp;( {userData && userData.roleName} ) </small>
                  </h1>
                </li>
              </ul>
            </div>
            {breadCrumbItems.length > 0 && <BreadCrumb items={breadCrumbItems} />}
          </div>
          {userData && userData.isImpersonatedUser && (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                height: "36px",
                width: "50%",
                color: "#000000",
                fontWeight: 400,
                fontSize: "17px"
              }}
            >
              <span className="bg-warning text-dark px-3 py-1 rounded">
                You are impersonating
                <span className="mx-1 fw-bold">
                  {userData.userFullName}
                </span>
              </span>

              {/* <button
            type="button"
            onClick={handleStopImpersonation}
            className="btn btn-sm btn-warning ms-3"
            style={{
              borderRadius: "5px",
              fontWeight: 600
            }}
          >
            Exit Impersonation
          </button> */}
            </div>
          )}

          <ul className="navbar-nav mx-auto">
            <MaintenanceAlert />
          </ul>

          <ul className="navbar-nav">
            {/* <li className="nav-item">
                            <form className="search-form" action="#">
                                <i className="icon-search"></i>
                                <input type="search" className="form-control" placeholder="Search Here" title="Search here" />
                            </form>
                        </li>
                        <li className="nav-item dropdown">
                            <span className="nav-link count-indicator cursor-pointer" id="notificationDropdown" data-bs-toggle="dropdown">
                                <i className="icon-message icon-lg"></i>
                            </span>
                            <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list pb-0" aria-labelledby="notificationDropdown">
                                <span className="cursor-pointer dropdown-item py-3 border-bottom">
                                    <p className="mb-0 font-weight-medium float-left">You have 4 new notifications </p>
                                    <span className="badge badge-pill badge-primary float-right">View all</span>
                                </span>
                                <span className="dropdown-item preview-item py-3 cursor-pointer">
                                    <div className="preview-thumbnail">
                                        <i className="mdi mdi-alert m-auto text-primary"></i>
                                    </div>
                                    <div className="preview-item-content">
                                        <h6 className="preview-subject fw-normal text-dark mb-1">Application Error</h6>
                                        <p className="fw-light small-text mb-0"> Just now </p>
                                    </div>
                                </span>
                                <span className="dropdown-item preview-item py-3 cursor-pointer">
                                    <div className="preview-thumbnail">
                                        <i className="mdi mdi-settings m-auto text-primary"></i>
                                    </div>
                                    <div className="preview-item-content">
                                        <h6 className="preview-subject fw-normal text-dark mb-1">Settings</h6>
                                        <p className="fw-light small-text mb-0"> Private message </p>
                                    </div>
                                </span>
                                <span className="dropdown-item preview-item py-3 cursor-pointer">
                                    <div className="preview-thumbnail">
                                        <i className="mdi mdi-airballoon m-auto text-primary"></i>
                                    </div>
                                    <div className="preview-item-content">
                                        <h6 className="preview-subject fw-normal text-dark mb-1">New user registration</h6>
                                        <p className="fw-light small-text mb-0"> 2 days ago </p>
                                    </div>
                                </span>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <span className="nav-link count-indicator" id="countDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="icon-notification"></i>
                                <span className="count"></span>
                            </span>
                            <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list pb-0" aria-labelledby="countDropdown">
                                <span className="dropdown-item py-3">
                                    <p className="mb-0 font-weight-medium float-left">You have 7 unread mails </p>
                                    <span className="badge badge-pill badge-primary float-right">View all</span>
                                </span>
                                <div className="dropdown-divider"></div>
                                <span className="dropdown-item preview-item">
                                    <div className="preview-thumbnail">
                                        <img src="assets/images/faces/face10.jpg" alt="img" className="img-sm profile-pic" />
                                    </div>
                                    <div className="preview-item-content flex-grow py-2">
                                        <p className="preview-subject ellipsis font-weight-medium text-dark">Marian Garner </p>
                                        <p className="fw-light small-text mb-0"> The meeting is cancelled </p>
                                    </div>
                                </span>
                                <span className="dropdown-item preview-item">
                                    <div className="preview-thumbnail">
                                        <img src="assets/images/faces/face12.jpg" alt="img" className="img-sm profile-pic" />
                                    </div>
                                    <div className="preview-item-content flex-grow py-2">
                                        <p className="preview-subject ellipsis font-weight-medium text-dark">David Grey </p>
                                        <p className="fw-light small-text mb-0"> The meeting is cancelled </p>
                                    </div>
                                </span>
                                <span className="dropdown-item preview-item">
                                    <div className="preview-thumbnail">
                                        <img src="assets/images/faces/face1.jpg" alt="img" className="img-sm profile-pic" />
                                    </div>
                                    <div className="preview-item-content flex-grow py-2">
                                        <p className="preview-subject ellipsis font-weight-medium text-dark">Travis Jenkins </p>
                                        <p className="fw-light small-text mb-0"> The meeting is cancelled </p>
                                    </div>
                                </span>
                            </div>
                        </li> */}
            <li className="nav-item dropdown d-none d-lg-block user-dropdown">
              <div className="d-flex gap-4 align-items-center">
                {/* {
                  checkActionAuthorization("upgrade", "Access To Copy Link For India Design Form") && (
                    <div>
                      <button type="button" onClick={handleCopyLink} className="btn btn-block  btn-success btn-md font-weight-medium m-0 btn-sm" style={{ borderRadius: 5 }}>
                        Copy ID 2025 Invite Link
                      </button>
                    </div>
                  )
                } */}
                {
                  checkActionAuthorization("upgrade", "Access To Copy Link For India Design Form") && (
                    <div>
                      <button type="button" onClick={showDialogForCopyIDEventInvitationLink}
                        className="btn btn-block  btn-success btn-md font-weight-medium m-0 btn-sm" style={{ borderRadius: 5 }}
                        disabled={isImpersonatedUser()}>
                        Copy ID {new Date().getFullYear()} Invite Link
                      </button>
                    </div>
                  )
                }

                <div className="w-full d-flex align-items-center gap-2 cursor-pointer">
                  {
                    (checkActionAuthorization("upgrade", "Access to show user level info") ||
                      checkActionAuthorization("upgrade", "Access to show technical level info")) && (
                      <>
                        <img
                          src="assets/images/info-img.svg"
                          className="info-svg mt-2"
                          onClick={() => fetchInfoData()} alt="info-img"
                        />
                      </>
                    )
                  }
                  {
                    currentProfilePicture && !IsStringNullEmptyOrUndefined(currentProfilePicture) || userData?.userProfileSignedUrl && !IsStringNullEmptyOrUndefined(userData?.userProfileSignedUrl) ? <span
                      className="nav-link mt-2 cursor-pointer"
                      id="UserDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <Image
                        src={currentProfilePicture && !IsStringNullEmptyOrUndefined(currentProfilePicture) ? currentProfilePicture : userData?.userProfileSignedUrl}
                        alt="Image"
                        width="40"
                        height="40"
                        className="profile-circle-img-d-head"
                      />
                    </span> : <span
                      className="nav-link cursor-pointer"
                      id="UserDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="mt-1 name-circle-upper"> {fetchUserNameLetter()} </span>
                    </span>
                  }

                  <div
                    className="dropdown-menu dropdown-menu-right navbar-dropdown user-profile-dropdown-top"
                  // aria-labelledby="UserDropdown"
                  >
                    {
                      currentProfilePicture && !IsStringNullEmptyOrUndefined(currentProfilePicture) || userData?.userProfileSignedUrl && !IsStringNullEmptyOrUndefined(userData?.userProfileSignedUrl) ?
                        <div className="dropdown-Header text-center p-2">
                          <span className="nav-link-d mt-2 cursor-pointer" style={{ position: 'relative', display: 'inline-block' }}>
                            <Image
                              src={currentProfilePicture && !IsStringNullEmptyOrUndefined(currentProfilePicture) ? currentProfilePicture : userData?.userProfileSignedUrl}
                              alt="Image"
                              width="40"
                              height="40"
                              className="profile-circle-img-d cursor-pointer"
                            />

                            {
                              (checkActionAuthorization("upgrade", "Allow User to View Photo") ||
                                checkActionAuthorization("upgrade", "Allow User to Change Photo")) &&
                              <div
                                className="overlay-d cursor-pointer"
                                onMouseEnter={() => setShowDropdown(true)}
                              >
                                <img src="assets/images/camera.svg" alt="Camera"
                                />
                                <div ref={previewImgRef} style={{ display: 'none' }}>
                                  <Image src={currentProfilePicture && !IsStringNullEmptyOrUndefined(currentProfilePicture) ? currentProfilePicture : userData?.userProfileSignedUrl} alt="Preview" preview />
                                </div>

                                {showDropdown && (

                                  <div className="dropdown-menu-custom dropdown-menu-custom-header">
                                    {checkActionAuthorization("upgrade", "Allow User to View Photo") &&
                                      <div
                                        className="dropdown-item-custom-header"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          triggerPreview();
                                        }}
                                      >
                                        View photo
                                      </div>}
                                    {checkActionAuthorization("upgrade", "Allow User to Change Photo") && <div
                                      className="dropdown-item-custom-header"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        document.getElementById('profileUploadInput')?.click();
                                      }}
                                    >
                                      Change photo
                                    </div>}


                                    {/* <div
                                    className="dropdown-item-custom-header"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeProfilePicture(e);
                                      setShowDropdown(false);
                                      const dropdown = document.querySelector('.dropdown-menu.show');
                                      if (dropdown) dropdown.classList.remove('show');
                                    }}
                                  >
                                    Remove photo
                                  </div> */}
                                  </div>

                                )}

                              </div>
                            }

                            <input
                              type="file"
                              id="profileUploadInput"
                              style={{ display: 'none' }}
                              accept=".png, .jpg, .jpeg"
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file && userData?._id) {
                                  updateProfilePicture(userData._id, file);
                                }
                              }}
                            />
                          </span>
                          <p className="mb-1 mt-3 font-weight-semibold mt-3">
                            {userData && render30CharcterAfterDot(userData.userFullName)}
                          </p>
                          <p className="fw-light text-muted mb-0">
                            {userData && render30CharcterAfterDot(userData.emailAddress)}
                          </p>
                        </div> : <div className="dropdown-Header name-wrapper text-center p-2">
                          <span className="name-circle-d mt-2 cursor-pointer" style={{ position: 'relative', display: 'inline-block' }}>
                            {" "}
                            {fetchUserNameLetter()}{" "}
                            <div
                              className="overlay-d cursor-pointer"
                              onClick={() => document.getElementById('profileUploadInput')?.click()}
                            >
                              <img src="assets/images/white-edit.svg" alt="Edit" />
                            </div>

                            <input
                              type="file"
                              id="profileUploadInput"
                              style={{ display: 'none' }}
                              accept=".png, .jpg, .jpeg"
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file && userData?._id) {
                                  updateProfilePicture(userData._id, file);
                                }
                              }}
                            />
                          </span>

                          <p className="mb-1 font-weight-semibold mt-3">
                            {userData &&
                              render30CharcterAfterDot(userData.userFullName)}
                          </p>
                          <p className="fw-light text-muted mb-0">
                            {userData &&
                              render30CharcterAfterDot(userData.emailAddress)}
                          </p>
                        </div>
                    }
                    <span className="dropdown-item">
                      <i className="dropdown-item-icon mdi mdi-account-outline text-primary me-2"></i>
                      My Profile
                      {/* <span className="badge badge-pill badge-danger">1</span> */}
                    </span>
                    {
                      !isImpersonatedUser() &&
                      <span
                        className="dropdown-item"
                        onClick={() => {
                          navigate("/user/change-password");
                        }}
                      >
                        <img
                          src="assets/images/reset-password.svg"
                          alt="Reset Password"
                          className="me-2"
                        />
                        Change Password
                      </span>
                    }
                    <span
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      <i className="dropdown-item-icon mdi mdi-power text-primary me-2"></i>
                      Sign Out
                    </span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <span onClick={toggleBodyClass} className="mdi mdi-menu"></span>
        </div>
      </nav >

      {isOrderBtnClicked &&
        <Dialog
          className="trafficLightModel"
          header="Commerical Hold Projects"
          visible={true}
          style={{ width: '63vw', overflow: 'hidden' }}
          onHide={handleCloseBtn}
          draggable={false}
          resizable={false}
          modal={true}
          blockScroll={true}

        >
          {commercialHoldOrderDetails && (
            <DataTable
              value={commercialHoldOrderDetails}
              scrollable
              className="architectsTable"
              scrollHeight="430px"
              style={{ border: "1px solid #ccc" }}
            >
              <Column field="srNo" header="Sr. No" />
              <Column field="orderNumber" header="Order Number" />
              <Column field="projectName" header="Project Name" />
              <Column field="commercialHoldDate" header="Commercial Hold Date" />
              <Column field="finalAmtWithDiscont" header="Total Amount" />
              {
                !isUserNameVisible && <Column field="userName" header="User Name" />
              }

            </DataTable>
          )}

        </Dialog>
      }

      {isFeedbackPendingOrderBtnClicked &&
        <Dialog
          className="trafficLightModel"
          header="Feedback Pending Projects"
          visible={true}
          style={{ width: '63vw', overflow: 'hidden' }}
          onHide={handleCloseBtn}
          draggable={false}
          resizable={false}
          modal={true}
          blockScroll={true}

        >
          {feedbackPendingOrderDetails && (
            <DataTable
              value={feedbackPendingOrderDetails}
              scrollable
              className="architectsTable"
              scrollHeight="430px"
              style={{ border: "1px solid #ccc" }}
            >
              <Column field="srNo" header="Sr. No" />
              <Column field="orderNumber" header="Order Number" />
              <Column field="projectName" header="Project Name" />
              {/* <Column field="commercialWinDate" header="Commercial Win Date" /> */}
              <Column field="finalAmtWithDiscont" header="Total Amount" />
              {
                !isUserNameVisible && <Column field="userName" header="User Name" />
              }

            </DataTable>
          )}

        </Dialog>
      }

      {
        isWebAppHandoverPendingOrdersBtnClicked &&
        <Dialog
          className="trafficLightModel"
          header="Webapp Handover Pending Projects"
          visible={true}
          style={{ width: '70vw', overflow: 'hidden' }}
          onHide={handleCloseBtn}
          draggable={false}
          resizable={false}
          modal={true}
          blockScroll={true}

        >
          {
            webappHandoverPendingOrderDetails && (
              <>
                <DataTable
                  value={webappHandoverPendingOrderDetails}
                  scrollable
                  className="architectsTable"
                  scrollHeight="430px"
                  style={{ border: "1px solid #ccc" }}
                >
                  <Column field="srNo" header="Sr. No" />
                  <Column field="officeName" header="Office" />
                  <Column field="orderNumber" header="Order Number" />
                  <Column field="projectName" header="Project Name" />
                  <Column field="handoverPendingDate" header="Handover Pending Date" />
                  <Column field="grandTotal" header="Total Amount" />
                  <Column field="salesPersonName" header="User Name" />
                  <Column field="netSales" header="Net Sales" />
                  <Column field="netCollection" header="Net Collection" />
                  <Column header="Closing Balance" body={(rowData) => {
                    return (
                      <span>{rowData.officeType === OfficeTypeEnum.DEALEROFFICE ? displayProjectClosingBalance(rowData.projectLedgerBalance) : "-"}</span>
                    )
                  }} />
                  {/* <Column field="due" header="Due" />
                  <Column field="overDue" header="Over Due" /> */}

                  <Column field="action" header="Action" body={(rowData: WebAppHandoverPendingOrderData) => {
                    return (
                      <div className="d-flex">
                        {
                          (
                            checkActionAuthorization("upgrade", "Access to refund payment")
                            && rowData.officeType === OfficeTypeEnum.DEALEROFFICE
                            && rowData.due <= 0
                          ) && (!isImpersonatedUser()) &&
                          <button className="btn btn-sm btn-success" type="button"
                            style={{ borderRadius: '5px' }}
                            onClick={() => {
                              onClickRefund(rowData.csRefNumber, Math.abs(rowData.overDue));
                            }}>
                            Refund
                          </button>
                        }

                        <img src="assets/images/info-hexagon.svg" alt="Info" className="ms-2 cursor-pointer" onClick={() => viewHandoverPendingOrderInfo(rowData)} />
                      </div>
                    )
                  }} />
                </DataTable>
              </>
            )
          }
        </Dialog>
      }

      {
        isSolutionBtnClicked &&
        <Dialog
          className="trafficLightModel"
          header="Production Hold Solutions"
          visible={true}
          style={{ width: '73vw', overflow: 'hidden' }}
          onHide={handleCloseBtn}
          draggable={false}
          resizable={false}

        >
          {productionHoldOrderDetails && (
            <DataTable
              value={productionHoldOrderDetails}
              scrollable
              scrollHeight="430px"
              className="architectsTable"
              style={{ border: "1px solid #ccc" }}
            >
              <Column field="srNo" header="Sr. No" />
              <Column field="orderNumber" header="Order Number" />
              <Column field="projectName" header="Project Name" />
              <Column field="finalAmtWithDiscont" header="Total Amount" />
              <Column field="solutionPrice" header="Solution Price" />
              <Column field="solutionNo" header="Location No" />
              <Column field="notifyDate" header="Hold Since/notifyDate" />
              {
                !isUserNameVisible && <Column field="userName" header="User Name" />
              }
            </DataTable>
          )}

        </Dialog>
      }

      <RedRibbonDataModel key={selectedWOStatus} isOpen={isOpenProductionWorkOrdersDetail} setIsOpen={setIsOpenProductionWorkOrdersDetail} title={workOrderModelTitle} status={selectedWOStatus} />

      <div className="card flex justify-content-center">
        <Dialog header="INFO" visible={visible} style={{ width: '70vw' }} onHide={() => { if (!visible) return; setVisible(false); }} footer={footerContent}>
          <TabView className='pricingVersionTabView'
            activeIndex={activeIndexs}
            onTabChange={(e) => setActiveIndexs(e.index)}>
            {
              checkActionAuthorization(
                "upgrade",
                "Access to show user level info"
              ) && (
                <TabPanel header="User Level">
                  {content.map((item, idx) => (
                    <div key={idx} className="mb-4">
                      {item?.userLevelContent && !IsStringNullEmptyOrUndefined(item.userLevelContent) ? (
                        <div className="content-email-for-editor editor-view">
                          <Editor value={item.userLevelContent} readOnly />
                        </div>
                      ) : (
                        <div className="alert alert-danger">
                          <h6>Information is currently unavailable</h6>
                        </div>
                      )}
                    </div>
                  ))}
                </TabPanel>)
            }
            {
              checkActionAuthorization(
                "upgrade",
                "Access to show technical level info"
              ) && (
                <TabPanel header="Technical Level">
                  {content.map((item, idx) => (
                    <div key={idx} className="mb-4">
                      {item && item.technicalLevelContent && !IsStringNullEmptyOrUndefined(item.technicalLevelContent) ? (
                        <div className="content-email-for-editor editor-view">
                          <Editor
                            value={item.technicalLevelContent}
                            readOnly
                          />
                        </div>
                      ) : <div className="alert alert-danger">
                        <h6>Information is currently unavailable</h6>
                      </div>}
                    </div>
                  ))}
                </TabPanel>)}
          </TabView>
        </Dialog>
      </div>

      <Dialog visible={isModelPipelinePending} onHide={() => setIsModelPipelinePending(false)} draggable={false} resizable={false} header="Pipeline projects have mapping pending." style={{ width: "70vw" }}>
        <DataTable
          value={pipelinePendingRecords}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          className="architectsTable"
          style={{ border: "1px solid #ccc" }}
        >
          <Column
            header="Sr. No"
            body={(_, options) => options.rowIndex + 1}
          />
          <Column field="orderNumber" header="Order Number" />
          <Column field="projectName" header="Project Name" />
          <Column field="state" header="State" />
          <Column field="city" header="City" />
          {
            checkActionAuthorization("update", "Waltz Orders") && (!isImpersonatedUser()) && (
              <Column field="action" header="Action" body={(rowData) => {
                return <img
                  src="assets/images/edit-icon.svg"
                  className="cursor-pointer"
                  alt="Edit"
                  onClick={() => {
                    fetchOrderEditDetails(rowData.orderId);
                  }}
                />
              }} />
            )
          }

        </DataTable>
      </Dialog>

      <Dialog visible={isModelSocialLeadDraftOrders} onHide={() => setIsModelSocialLeadDraftOrders(false)} draggable={false} resizable={false} header="Social Lead Draft Orders" style={{ width: "70vw" }}>
        <DataTable
          value={socialLeadDraftRecords}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          className="architectsTable"
          style={{ border: "1px solid #ccc" }}
        >
          <Column
            header="Sr. No"
            body={(_, options) => options.rowIndex + 1}
          />
          <Column field="orderNumber" header="Order Number" />
          <Column field="projectName" header="Project Name" />
          <Column field="state" header="State" />
          <Column field="city" header="City" />
          {
            checkActionAuthorization("update", "Waltz Orders") && (!isImpersonatedUser()) && (
              <Column field="action" header="Action" body={(rowData) => {
                return <img
                  src="assets/images/edit-icon.svg"
                  className="cursor-pointer"
                  alt="Edit"
                  onClick={() => {
                    fetchOrderEditDetails(rowData.orderId);
                  }}
                />
              }} />
            )
          }
        </DataTable>
      </Dialog>

      <Dialog visible={isModelWinPending} onHide={() => setIsModelWinPending(false)} draggable={false} resizable={false} header="Win projects have mapping pending." style={{ width: "70vw" }}>
        <DataTable
          value={winPendingRecords}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          className="architectsTable"
          style={{ border: "1px solid #ccc" }}
        >
          <Column
            header="Sr. No"
            body={(_, options) => options.rowIndex + 1}
          />
          <Column field="orderNumber" header="Order Number" />
          <Column field="projectName" header="Project Name" />
          <Column field="state" header="State" />
          <Column field="city" header="City" />
          {
            checkActionAuthorization("update", "Waltz Orders") && (!isImpersonatedUser()) && (
              <Column field="action" header="Action" body={(rowData) => {
                return <img
                  src="assets/images/edit-icon.svg"
                  className="cursor-pointer"
                  alt="Edit"
                  onClick={() => {
                    fetchOrderEditDetails(rowData.orderId);
                  }}
                />
              }} />
            )
          }

        </DataTable>
      </Dialog>

      <Dialog visible={isModelNotFeasiblePendingOrder} onHide={() => setIsModelNotFeasiblePendingOrder(false)} draggable={false} resizable={false} header="Not feasible orders" style={{ width: "70vw" }}>
        <DataTable
          value={notFeasibleRecords}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          className="architectsTable"
          style={{ border: "1px solid #ccc" }}
        >
          <Column
            header="Sr. No"
            body={(_, options) => options.rowIndex + 1}
          />
          <Column field="orderNumber" header="Order Number" />
          <Column field="projectName" header="Project Name" />
          <Column field="userName" header="Sales Head" />
          <Column field="officeName" header="Office Name" />
          <Column field="totalAmount" header="Total Amount" />
          <Column field="notFeasibleLocationCount" header="Not Feasible Locations" />
          {
            checkActionAuthorization("update", "Waltz Orders") && (!isImpersonatedUser()) && (
              <Column field="action" header="Action" body={(rowData) => {
                return <img
                  src="assets/images/edit-icon.svg"
                  className="cursor-pointer"
                  alt="Edit"
                  onClick={() => {
                    fetchOrderEditDetails(rowData.orderId);
                  }}
                />
              }} />
            )
          }

        </DataTable>
      </Dialog>

      <Dialog visible={isModelShopDrawingAwaitingOrder} onHide={() => setIsModelShopDrawingAwaitingOrder(false)} draggable={false} resizable={false} header="Shop Drawing Awaiting Orders" style={{ width: "70vw" }}>
        <DataTable
          value={shopDrawingAwaitingRecords}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          className="architectsTable"
          style={{ border: "1px solid #ccc" }}
        >
          <Column
            header="Sr. No"
            body={(_, options) => options.rowIndex + 1}
          />
          <Column field="orderNumber" header="Order Number" />
          <Column field="projectName" header="Project Name" />
          <Column field="userName" header="Sales Head" />
          <Column field="officeName" header="Office Name" />
          <Column field="totalAmount" header="Total Amount" />
          <Column field="shopDrawingAwaitingLocationCount" header="Shop Drawing Awaiting Locations" />
          {
            checkActionAuthorization("list", "Production Planning") && checkActionAuthorization("list", "DM BIC Data") && (!isImpersonatedUser()) && (
              <Column field="action" header="Action" body={(rowData) => {
                return <img
                  src="assets/images/edit-icon.svg"
                  className="cursor-pointer"
                  alt="Edit"
                  onClick={() => {
                    setIsModelShopDrawingAwaitingOrder(false);
                    navigate(`/project-manager-bic-data/shop-drawing-awaiting/${rowData.orderId}`);
                  }}
                />
              }} />
            )
          }

        </DataTable>
      </Dialog>

      <Dialog visible={isModelShopDrawingApprovalPendingOrder} onHide={() => setIsModelShopDrawingApprovalPendingOrder(false)} draggable={false} resizable={false} header="Shop Drawing Approval Pending orders" style={{ width: "70vw" }}>
        <DataTable
          value={shopDrawingApprovalPendingRecords}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          className="architectsTable"
          style={{ border: "1px solid #ccc" }}
        >
          <Column
            header="Sr. No"
            body={(_, options) => options.rowIndex + 1}
          />
          <Column field="orderNumber" header="Order Number" />
          <Column field="projectName" header="Project Name" />
          <Column field="userName" header="Sales Head" />
          <Column field="officeName" header="Office Name" />
          <Column field="totalAmount" header="Total Amount" />
          <Column field="shopDrawingApprovalPendingLocationCount" header="Shop Drawing Approval Pending Locations" />
          {
            checkActionAuthorization("update", "Waltz Orders") && checkActionAuthorization("upgrade", "Access to SD approve") && (!isImpersonatedUser()) && (
              <Column field="action" header="Action" body={(rowData) => {
                return <img
                  src="assets/images/edit-icon.svg"
                  className="cursor-pointer"
                  alt="Edit"
                  onClick={() => {
                    fetchOrderEditDetails(rowData.orderId);
                  }}
                />
              }} />
            )
          }
        </DataTable>
      </Dialog>

      <CopyIDEventLink
        visible={showDialogForCopyIDInvitationLink}
        setVisible={setShowDialogForCopyIDInvitationLink}
        passStatiSticsCB={passStatiSticsCB}
        isActionDisabled={isImpersonatedUser()}
      />

      {
        handOverPendingOrderPaymentInfo && !IsNullOrUndefined(handOverPendingOrderPaymentInfo) &&
        <HandoverPendingOrderPaymentInfo
          handOverPendingOrderPaymentInfo={handOverPendingOrderPaymentInfo}
          showDialogHandOverPendingInfo={showDialogHandOverPendingInfo}
          setShowDialogHandOverPendingInfo={setShowDialogHandOverPendingInfo}
          refundBtnCB={(csRefNumber: string, overDue: number) => {
            if (isImpersonatedUser()) return;
            onClickRefund(csRefNumber, overDue);
          }}
          isActionDisabled={isImpersonatedUser()}
        />
      }

      {
        isLocationModelOpen && !IsNullOrEmptyArray(locationStatusDetails) && (
          <SolutionStatusModel data={locationStatusDetails} isOpen={isLocationModelOpen} onClose={handleLocationModelClose} onOpen={handleLocationModelOpen} status={getFormattedStatusName(selectedStatus)} />
        )
      }
    </>
  );
}

export default Header;
